import { render, staticRenderFns } from "./InputSiNo.vue?vue&type=template&id=863c63b8&scoped=true&"
import script from "./InputSiNo.vue?vue&type=script&lang=js&"
export * from "./InputSiNo.vue?vue&type=script&lang=js&"
import style0 from "./InputSiNo.vue?vue&type=style&index=0&id=863c63b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863c63b8",
  null
  
)

export default component.exports